import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

// Import the modal components
import { NewUserProjectComponent } from '../../layouts/my-projects/new-project/project-permissions/new-user-project/new-user-project.component';

// Import shared dependencies
import { SharedModule } from '../SharedModule';

@NgModule({
  declarations: [NewUserProjectComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbModule, NgSelectModule, SharedModule],
  exports: [NewUserProjectComponent],
})
export class ProjectModalsModule {}
